export default {
  install: (app) => {
    // Konstante Daten
    const pluginData = {
      zahnarzt: '14.000',
      // Weitere Daten hier...
    };

    // Methode zum Abrufen von Daten
    const getData = (key) => {
      return key ? pluginData[key] : pluginData;
    };

    // Das Plugin als provide/inject-Wert registrieren
    app.provide('dataplugin', {
      getData,
      pluginData
    });
  }
};
